/**
 * Opens a user-entered URL in a new tab, prepending https:// when the
 * value has no explicit scheme.
 */
export const openExternalUrl = (raw) => {
  const url = String(raw || '').trim();
  if (!url) return;
  const full = /^https?:\/\//i.test(url) ? url : `https://${url}`;
  window.open(full, '_blank', 'noopener');
};
